import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';

/* TRADUCCIONES ESPAÑOL */
import login_es from "./translations/es/login.json";
import footer_es from "./translations/es/footer.json";
import cookies_es from "./translations/es/cookies.json";
import updates_es from "./translations/es/updates.json";
import navbar_es from "./translations/es/navbar.json";
import header_es from "./translations/es/header.json";
import subscription_es from "./translations/es/subscription.json";
import legal_es from "./translations/es/legal.json";
import formation_es from "./translations/es/formation.json";
import companies_es from "./translations/es/companies.json";
import users_es from "./translations/es/users.json";
import incidents_es from "./translations/es/incidents.json";
import notifications_es from "./translations/es/notifications.json";
import table_es from "./translations/es/table.json";
import filters_es from "./translations/es/filters.json";
import formcard_es from "./translations/es/formcard.json";
import commonCard_es from "./translations/es/commonCard.json";
import customDropdown_es from "./translations/es/customDropdown.json";
import accessDenied_es from "./translations/es/accessDenied.json";
import publicIncident_es from "./translations/es/publicIncident.json";
import services_es from "./translations/es/services.json";
import certificate_es from "./translations/es/certificate.json";
import metrics_es from "./translations/es/metrics.json";

/* TRADUCCIONES CATALÁN */
import login_ca from "./translations/ca/login.json";
import footer_ca from "./translations/ca/footer.json";
import cookies_ca from "./translations/ca/cookies.json";
import updates_ca from "./translations/ca/updates.json";
import navbar_ca from "./translations/ca/navbar.json";
import header_ca from "./translations/ca/header.json";
import subscription_ca from "./translations/ca/subscription.json";
import legal_ca from "./translations/ca/legal.json";
import formation_ca from "./translations/ca/formation.json";
import companies_ca from "./translations/ca/companies.json";
import users_ca from "./translations/ca/users.json";
import incidents_ca from "./translations/ca/incidents.json";
import notifications_ca from "./translations/ca/notifications.json";
import table_ca from "./translations/ca/table.json";
import filters_ca from "./translations/ca/filters.json";
import formcard_ca from "./translations/ca/formcard.json";
import commonCard_ca from "./translations/ca/commonCard.json";
import customDropdown_ca from "./translations/ca/customDropdown.json";
import accessDenied_ca from "./translations/ca/accessDenied.json";
import publicIncident_ca from "./translations/ca/publicIncident.json";
import services_ca from "./translations/ca/services.json";
import certificate_ca from "./translations/ca/certificate.json";
import metrics_ca from "./translations/ca/metrics.json";


/* TRADUCCIONES EUSKERA */
import login_eu from "./translations/eu/login.json";
import footer_eu from "./translations/eu/footer.json";
import cookies_eu from "./translations/eu/cookies.json";
import updates_eu from "./translations/eu/updates.json";
import navbar_eu from "./translations/eu/navbar.json";
import header_eu from "./translations/eu/header.json";
import subscription_eu from "./translations/eu/subscription.json";
import legal_eu from "./translations/eu/legal.json";
import formation_eu from "./translations/eu/formation.json";
import companies_eu from "./translations/eu/companies.json";
import users_eu from "./translations/eu/users.json";
import incidents_eu from "./translations/eu/incidents.json";
import notifications_eu from "./translations/eu/notifications.json";
import table_eu from "./translations/eu/table.json";
import filters_eu from "./translations/eu/filters.json";
import formcard_eu from "./translations/eu/formcard.json";
import commonCard_eu from "./translations/eu/commonCard.json";
import customDropdown_eu from "./translations/eu/customDropdown.json";
import accessDenied_eu from "./translations/eu/accessDenied.json";
import publicIncident_eu from "./translations/eu/publicIncident.json";
import services_eu from "./translations/eu/services.json";
import certificate_eu from "./translations/eu/certificate.json";
import metrics_eu from "./translations/eu/metrics.json";


/* TRADUCCIONES INGLES */
import login_en from "./translations/en/login.json";
import footer_en from "./translations/en/footer.json";
import cookies_en from "./translations/en/cookies.json";
import updates_en from "./translations/en/updates.json";
import navbar_en from "./translations/en/navbar.json";
import header_en from "./translations/en/header.json";
import subscription_en from "./translations/en/subscription.json";
import legal_en from "./translations/en/legal.json";
import formation_en from "./translations/en/formation.json";
import companies_en from "./translations/en/companies.json";
import users_en from "./translations/en/users.json";
import incidents_en from "./translations/en/incidents.json";
import notifications_en from "./translations/en/notifications.json";
import table_en from "./translations/en/table.json";
import filters_en from "./translations/en/filters.json";
import formcard_en from "./translations/en/formcard.json";
import commonCard_en from "./translations/en/commonCard.json";
import customDropdown_en from "./translations/en/customDropdown.json";
import accessDenied_en from "./translations/en/accessDenied.json";
import publicIncident_en from "./translations/en/publicIncident.json";
import services_en from "./translations/en/services.json";
import certificate_en from "./translations/en/certificate.json";
import metrics_en from "./translations/en/metrics.json";

/* TRADUCCIONES ITALIANO */
import login_it from "./translations/it/login.json";
import footer_it from "./translations/it/footer.json";
import cookies_it from "./translations/it/cookies.json";
import updates_it from "./translations/it/updates.json";
import navbar_it from "./translations/it/navbar.json";
import header_it from "./translations/it/header.json";
import subscription_it from "./translations/it/subscription.json";
import legal_it from "./translations/it/legal.json";
import formation_it from "./translations/it/formation.json";
import companies_it from "./translations/it/companies.json";
import users_it from "./translations/it/users.json";
import incidents_it from "./translations/it/incidents.json";
import notifications_it from "./translations/it/notifications.json";
import table_it from "./translations/it/table.json";
import filters_it from "./translations/it/filters.json";
import formcard_it from "./translations/it/formcard.json";
import commonCard_it from "./translations/it/commonCard.json";
import customDropdown_it from "./translations/it/customDropdown.json";
import accessDenied_it from "./translations/it/accessDenied.json";
import publicIncident_it from "./translations/it/publicIncident.json";
import services_it from "./translations/it/services.json";
import certificate_it from "./translations/it/certificate.json";
import metrics_it from "./translations/it/metrics.json";

i18next.init({
  interpolation: { escapeValue: false },
  lng: "es",
  fallbackLng: "es",
  resources: {
    es: {
      login: login_es,
      navbar: navbar_es,
      header: header_es,
      footer: footer_es,
      cookies: cookies_es,
      updates: updates_es,
      subscription: subscription_es,
      legal: legal_es,
      formation: formation_es,
      companies: companies_es,
      users: users_es,
      incidents: incidents_es,
      notifications: notifications_es,
      table: table_es,
      filters: filters_es,
      formcard: formcard_es,
      commoncard: commonCard_es,
      customDropdown: customDropdown_es,
      accessDenied: accessDenied_es,
      publicIncident: publicIncident_es,
      services: services_es,
      certificate: certificate_es,
      metrics: metrics_es,

    },
    ca: {
      login: login_ca,
      navbar: navbar_ca,
      header: header_ca,
      footer: footer_ca,
      cookies: cookies_ca,
      updates: updates_ca,
      subscription: subscription_ca,
      legal: legal_ca,
      formation: formation_ca,
      companies: companies_ca,
      users: users_ca,
      incidents: incidents_ca,
      notifications: notifications_ca,
      table: table_ca,
      filters: filters_ca,
      formcard: formcard_ca,
      commoncard: commonCard_ca,
      customDropdown: customDropdown_ca,
      accessDenied: accessDenied_ca,
      publicIncident: publicIncident_ca,
      services: services_ca,
      certificate: certificate_ca,
      metrics: metrics_ca,
    },
    eu: {
      login: login_eu,
      navbar: navbar_eu,
      header: header_eu,
      footer: footer_eu,
      cookies: cookies_eu,
      updates: updates_eu,
      subscription: subscription_eu,
      legal: legal_eu,
      formation: formation_eu,
      companies: companies_eu,
      users: users_eu,
      incidents: incidents_eu,
      notifications: notifications_eu,
      table: table_eu,
      filters: filters_eu,
      formcard: formcard_eu,
      commoncard: commonCard_eu,
      customDropdown: customDropdown_eu,
      accessDenied: accessDenied_eu,
      publicIncident: publicIncident_eu,
      services: services_eu,
      certificate: certificate_eu,
      metrics: metrics_eu,
    },
    en: {
      login: login_en,
      navbar: navbar_en,
      header: header_en,
      footer: footer_en,
      cookies: cookies_en,
      updates: updates_en,
      subscription: subscription_en,
      legal: legal_en,
      formation: formation_en,
      companies: companies_en,
      users: users_en,
      incidents: incidents_en,
      notifications: notifications_en,
      table: table_en,
      filters: filters_en,
      formcard: formcard_en,
      commoncard: commonCard_en,
      customDropdown: customDropdown_en,
      accessDenied: accessDenied_en,
      publicIncident: publicIncident_en,
      services: services_en,
      certificate: certificate_en,
      metrics: metrics_en,
    },
    it: {
      login: login_it,
      navbar: navbar_it,
      header: header_it,
      footer: footer_it,
      cookies: cookies_it,
      updates: updates_it,
      subscription: subscription_it,
      legal: legal_it,
      formation: formation_it,
      companies: companies_it,
      users: users_it,
      incidents: incidents_it,
      notifications: notifications_it,
      table: table_it,
      filters: filters_it,
      formcard: formcard_it,
      commoncard: commonCard_it,
      customDropdown: customDropdown_it,
      accessDenied: accessDenied_it,
      publicIncident: publicIncident_it,
      services: services_it,
      certificate: certificate_it,
      metrics: metrics_it,
    },
  }
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
